import { init } from 'client/tubiDebugBridge';
import type { TubiStore } from 'common/types/storeState';

export const setupTubiDebugBridge = (store: TubiStore) => {
  init(store);
};
